export default function exportTable(format, fileBaseName, header, data) {
  import("CommonCore/exporters").then(Exporters => {
    Exporters.default[format](fileBaseName, header, data);
  }).catch(error => {
    console.error("Failed to load module 'CommonCore/exporters':", error);
  });
}
